import React from 'react';
import Login from '../layout/Login';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../service/AuthContext';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../service/Firebase-config';

const roleImages = {
  admin: 'https://firebasestorage.googleapis.com/v0/b/drhw-prod.appspot.com/o/common%2FloginAdmin.jpg?alt=media&token=08b0d769-563a-433b-bcf0-e9320c336468',
  teacher: 'https://firebasestorage.googleapis.com/v0/b/drhw-prod.appspot.com/o/common%2FloginTeacher.jpg?alt=media&token=98c71c4c-1a5c-4be0-bb28-046d14568ff6',
  student: 'https://firebasestorage.googleapis.com/v0/b/drhw-prod.appspot.com/o/common%2FloginStudent.jpg?alt=media&token=ff136450-c777-416b-b5e2-033de088a912'
};

export default function LoginPage() {
  const { role } = useParams();
  const { login, setUserInfo, logout } = useAuth();
  const navigate = useNavigate();

  async function loginAsRole(email, password) {
    try {
      await login(email, password).then(async (u) => {
        const dbRole = role === 'admin' ? 'teachers' : `${role}s`;

        const userInfo = await getDoc(doc(db, dbRole, u.user.uid));
        if (userInfo.exists()) {
          const userRole = userInfo.data().role;
          let isAuth = false;

          if (role === 'teacher') {
            if (userRole === 'teacher' || userRole === 'admin') {
              isAuth = true;
            }
          } else if (userRole === role) {
            isAuth = true;
          }

          if (isAuth) {
            setUserInfo(userInfo.data());
            navigate(`/main/${role}`);
          } else {
            await logout();
            alert(`Login error: Not a ${role}`);
          }
        } else {
          await logout();
          alert(`Login error: Not a ${role}`);
        }
      });
    } catch (err) {
      alert("Login error: " + err.message);
    }
  }

  return (
    <Login value={{ role: role.charAt(0).toUpperCase() + role.slice(1), image: roleImages[role], loginAs: loginAsRole }} />
  );
}
